import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import { selectActualCompanyId } from 'containers/App/selectors'

import { submitFirstLoginError, submitFirstLoginSuccess } from './actions'
import { SUBMIT_FIRST_LOGIN_ASYNC } from './constants'

const submitFirstLoginEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_FIRST_LOGIN_ASYNC.INITIATE).mergeMap((action) =>
    api.login
      .submitFirstLogin({
        ...action.payload.data,
        company_id: selectActualCompanyId(store.getState()),
      })
      .map(({ response }) => submitFirstLoginSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(submitFirstLoginError, error)))
  )

export default combineEpics(submitFirstLoginEpic)
